module.exports = __webpack_public_path__ + "static/media/menu.287b26fb.svg";